module.exports = __webpack_public_path__ + "static/covid-19-1-3189117c7b7b1c6ce815c6e3e5172575.gif";